import React, { useState } from 'react';

import {
    Box,
    Button,
    Card,
    Grid,
    Tooltip,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Modal } from 'common/components';

import companyUsers from '../../companyUsers';
import * as actions from '../actions';

import SelectUserForm from './SelectUserForm';

const CardAssignUser = ({
    allianceId,
    canModify,
    fetchFinancierInstaller,
    fetchUsers,
    users,
    userTracking,
}) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const handleOnClickAssignUser = () => setShowModal(true);
    const handleOnEnter = () => fetchUsers();
    const handleOnHide = () => setShowModal(false);
    const handleOnCallback = () => {
        fetchFinancierInstaller(allianceId);
        setShowModal(false);
    };
    const user = get(userTracking, 'user', null);

    return (
        <Card>
            <Card.Body>
                <Grid alignItems="start" container>
                    <Grid size={{ md: 14, xs: 18 }}>
                        <Box display="flex" gap={1}>
                            <Typography fontWeight="bold" variant="caption">
                                {t('Company executive')}:
                            </Typography>

                            <Typography variant="caption">
                                {user !== null ? (
                                    <React.Fragment>{`${user?.first_name} ${user?.last_name} ${user?.second_surname}`}</React.Fragment>
                                ) : (
                                    t('No user assigned')
                                )}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid
                        hidden={!canModify}
                        size={{ md: 4, xs: 18 }}
                        textAlign="right"
                    >
                        <Tooltip title={t('Company executive')}>
                            <Button
                                color="secondary"
                                onClick={handleOnClickAssignUser}
                                size="small"
                                variant="text"
                            >
                                {user === null ? t('Assign') : t('Change')}{' '}
                                {t('Executive')}
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Card.Body>

            <Modal
                onEnter={handleOnEnter}
                onHide={handleOnHide}
                show={showModal}
                size="sm"
                title={t('Assign company executive')}
            >
                <SelectUserForm
                    allianceId={allianceId}
                    callback={handleOnCallback}
                    users={users}
                />
            </Modal>
        </Card>
    );
};

const mapStateToProps = createStructuredSelector({
    users: companyUsers.selectors.getFetchItemsListData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchFinancierInstaller: (id) =>
        dispatch(actions.fetchFinancierInstaller(id)),
    fetchUsers: () => dispatch(companyUsers.actions.fetchItems()),
});

CardAssignUser.propTypes = {
    allianceId: PropTypes.string,
    canModify: PropTypes.bool,
    fetchFinancierInstaller: PropTypes.func,
    fetchUsers: PropTypes.func,
    users: PropTypes.array,
    userTracking: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardAssignUser);
